import { ExportReq, HttpService, Records } from "@/core";
import { ExportResp } from "@/core/interface";
import {
  SubcontractPaymentPageReq,
  SubcontractPaymentPageResp,
  SubcontractPaymentReq,
  SubcontractPaymentResp,
  SubcontractApplySimpleListReq,
  SubcontractApplySimpleRecord,
  SubcontractApplyAmountResp,
} from "./subcontract-payment.interface";

export class SubcontractPaymentService {
  static usePageApi() {
    const api = (params: SubcontractPaymentPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/subcontract_payment_apply/page",
        params,
      });
    return HttpService.usePagination<SubcontractPaymentPageResp>(api);
  }

  static useExportApi() {
    const api = (ids: ExportReq) =>
      HttpService.axios({
        method: "POST",
        url: "/subcontract_payment_apply/export",
        params: { ids },
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/subcontract_payment_apply/${id}`,
      });
    return HttpService.useRequest<SubcontractPaymentResp>(api);
  }

  static useCreateApi() {
    const api = (data: SubcontractPaymentReq) =>
      HttpService.axios({
        method: "POST",
        url: "/subcontract_payment_apply",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useEditApi() {
    const api = (id: string, data: SubcontractPaymentReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/subcontract_payment_apply/${id}`,
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useContractSimpleListApi() {
    const api = (params: SubcontractApplySimpleListReq) =>
      HttpService.axios({
        method: "GET",
        url: "/subcontract/simple/apply/list",
        params,
      });
    return HttpService.usePagination<SubcontractApplySimpleRecord>(api);
  }

  static useContractAmountApi() {
    const api = (subcontractId) =>
      HttpService.axios({
        method: "GET",
        url: "/subcontract_payment_apply/amount/detail",
        params: { subcontractId },
      });
    return HttpService.useRequest<SubcontractApplyAmountResp>(api);
  }
}
